import {optionalMaterialInput} from "#material/nodes/base/connection/validation/parameters"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {ExchangeNodeName} from "#material/exchange/node-name"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {color} from "@cm/graph-v3"
import {z} from "zod/v4-mini"
import {materialClosureOutput} from "#material/nodes/base/material/validation/io"

export interface EmissionSockets extends MaterialNodeSockets {
    inputs: {
        color: "color" // found in inputs: color; found in settings: color; inferred from data: float3
        strength: "float" // found in inputs: float; found in settings: float; inferred from data: float
    }
    settings: {
        color: "color" // found in inputs: color; found in settings: color; inferred from data: float3
        strength: "float" // found in inputs: float; found in settings: float; inferred from data: float
    }
    outputs: {
        emission: "closure"
    }
}

export const emissionDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeEmission,
    },
    nodeClass: "Emission",
    ui: {
        label: "Emission",
        color: "#2d8a5d",
        items: [
            {
                name: "emission",
                label: "Emission",
                valueType: "closure",
                output: true,
            },
            {name: "color", label: "Color", valueType: "color", input: true, setting: true, defaultValue: {r: 0.8, g: 0.8, b: 0.8}},
            {
                name: "strength",
                label: "Strength",
                valueType: "float",
                defaultValue: 10,
                range: {
                    min: 0,
                    max: 100,
                },
                input: true,
                setting: true,
            },
        ],
        support: {
            cycles: true,
            three: true,
        },
    },
    validation: {
        returns: z.strictObject({emission: materialClosureOutput}),
        parameters: z.strictObject({
            inputs: z.strictObject({color: optionalMaterialInput, strength: optionalMaterialInput}),
            settings: z.strictObject({
                color: z.optional(color),
                strength: z.optional(z.number()),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<EmissionSockets>
